import { CardComponentProps } from "@~/types/types";
import styles from "./QuantityPurchased.module.scss";

export function QuantityPurchased({
  product,
}: Pick<CardComponentProps, "product">) {
  if (product.wanted === undefined) {
    return null;
  }

  return (
    <div data-component="pcl-QuantityPurchased">
      <h2 className={styles.title}>
        {product.purchased || 0} of {product.wanted} purchased
      </h2>
    </div>
  );
}
